import { render, staticRenderFns } from "./AdminSoftware.vue?vue&type=template&id=187eeed0&"
import script from "./AdminSoftware.vue?vue&type=script&lang=js&"
export * from "./AdminSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports